import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Link as ScrollLink } from "react-scroll";


const phoneNumber = "+92 309 5205279";
const address = "PR1 6LL 281 deepdale road UK";


let socialList = [
    {
        iconName: 'icofont-facebook',
        siteLink: '#',
    },
    {
        iconName: 'icofont-linkedin',
        siteLink: '#',
    },
    {
        iconName: 'icofont-instagram',
        siteLink: '#',
    },
    {
        iconName: 'icofont-youtube',
        siteLink: '#',
    },
    // {
    //     iconName: 'icofont-vimeo',
    //     siteLink: '#',
    // },
    // {
    //     iconName: 'icofont-skype',
    //     siteLink: '#',
    // },
    // {
    //     iconName: 'icofont-rss-feed',
    //     siteLink: '#',
    // },
]

const Header = () => {
    const [menuToggle, setMenuToggle] = useState(false);
    const [socialToggle, setSocialToggle] = useState(false);
    const [headerFiexd, setHeaderFiexd] = useState(false);

    window.addEventListener("scroll", () => {
        if (window.scrollY > 200) {
            setHeaderFiexd(true);
        } else {
            setHeaderFiexd(false);
        }
    });

    return (
        <header className={`header-section ${headerFiexd ? "header-fixed fadeInUp" : ""}`}>
            <div className={`header-top ${socialToggle ? "open" : ""}`}>
                <div className="container">
                    <div className="header-top-area">
                        <ul className="lab-ul left">
                            <li><i className="icofont-ui-call"></i> <span>{phoneNumber}</span></li>
                            <li><i className="icofont-location-pin"></i> {address}</li>
                        </ul>
                        <ul className="lab-ul social-icons d-flex align-items-center">
                            <li><p>Find us on : </p></li>
                            {socialList.map((val, i) => (
                                <li key={i}><a href={val.siteLink}><i className={val.iconName}></i></a></li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
            <div className="header-bottom">
                <div className="container">
                    <div className="header-wrapper">
                        <div className="logo">
                            <Link to="/"><img width={150} src="assets/images/logo/logo.png" alt="logo" /></Link>
                            {/* <h6>Applying <span style={{color: "#0073E6"}}>Hub</span></h6> */}
                        </div>
                        <div className="menu-area">
                            <div className="menu">
                                <ul className={`lab-ul ${menuToggle ? "active" : ""}`}>
                                    <li className="">
                                        <a href="#" role="button" data-bs-toggle="" aria-haspopup="true" aria-expanded="false" data-bs-offset="0,0"><Link to="/" smooth={true} duration={500}>Home</Link></a>

                                    </li>
                                    <li className="">
                                        <a href="#" role="button" data-bs-toggle="" aria-haspopup="true" aria-expanded="false" data-bs-offset="0,0"><ScrollLink to="courses" smooth={true} duration={500}>Courses</ScrollLink></a>

                                    </li>
                                    <li className="">
                                        <a href="#" role="button" data-bs-toggle="" aria-haspopup="true" aria-expanded="false" data-bs-offset="0,0"><ScrollLink to="country" smooth={true} duration={500}>Country</ScrollLink></a>

                                    </li>
                                    <li className="">
                                        <a href="#" role="button" data-bs-toggle="" aria-haspopup="true" aria-expanded="false" data-bs-offset="0,0"><Link to="/partner">Partner with us</Link></a>

                                    </li>
                                    {/* <li className="">
                                        <a href="#" role="button" data-bs-toggle="" aria-haspopup="true" aria-expanded="false" data-bs-offset="0,0"><ScrollLink to="services" smooth={true} duration={500}>Services</ScrollLink></a>
                                      
                                    </li> */}
                                    <li className="">
                                        <a href="#" role="button" data-bs-toggle="" aria-haspopup="true" aria-expanded="false" data-bs-offset="0,0"><Link to="/instructor" >Student Apply</Link></a>

                                    </li>
                                    {/* <li className="">
                                        <a href="#" role="button" data-bs-toggle="" aria-haspopup="true" aria-expanded="false" data-bs-offset="0,0"><ScrollLink to="blog" smooth={true} duration={500}>Blog</ScrollLink></a>
                                      
                                    </li> */}

                                    <li><a href="#" role="button" data-bs-toggle="" aria-haspopup="true" aria-expanded="false" data-bs-offset="0,0"><ScrollLink to="contact" smooth={true} duration={500}>Contact</ScrollLink></a></li>
                                    <li className="block md:hidden"><a href="https://portal.applyinghub.com/" role="button" data-bs-toggle="" aria-haspopup="true" aria-expanded="false" data-bs-offset="0,0">Login</a></li>
                                    <li className="block md:hidden"><a href="https://portal.applyinghub.com/" role="button" data-bs-toggle="" aria-haspopup="true" aria-expanded="false" data-bs-offset="0,0">Sign up</a></li>
                                </ul>
                            </div>

                            <a
                                href="https://portal.applyinghub.com/"
                                target="_blank"
                                className="bg-white p-2 hidden md:inline-flex items-center gap-2  rounded"
                            >
                                <i className="icofont-user"></i>
                                <span>LOG IN</span>
                            </a>

                            <a
                                href="https://portal.applyinghub.com/"
                                target="_blank"
                                className="p-2 text-white bg-[#0073E6] hidden md:inline-flex items-center gap-2  rounded"
                            >
                                <i className="icofont-users"></i>
                                <span>SIGN UP</span>
                            </a>


                            <div className={`header-bar d-lg-none ${menuToggle ? "active" : ""}`} onClick={() => setMenuToggle(!menuToggle)}>
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
}

export default Header;